import React, { useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    projectTitle: "",
    budget: "",
    startDate: "",
    description: "",
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required.";
    if (!formData.email) {
      newErrors.email = "Email is required.";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address.";
    }
    if (!formData.description) newErrors.description = "Description is required.";
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({ ...errors, [name]: "" }); // Clear error on input change
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    console.log("Form Data Submitted:", formData);
    alert("Thank you for contacting us!");
    setFormData({
      name: "",
      email: "",
      company: "",
      projectTitle: "",
      budget: "",
      startDate: "",
      description: "",
    });
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "transparent",
        padding: "2rem",
        fontFamily: "Arial, sans-serif",
      }}
    >
      {/* Page Header */}
      <div style={{ textAlign: "center", marginBottom: "2rem" }}>
        <h2 style={{ fontSize: "2.5rem", fontWeight: "bold", color: "#333" }}>
          Contact the Geological Students Society
        </h2>
        <p style={{ marginTop: "1rem", fontSize: "1.1rem", color: "#555" }}>
          Get in touch with us for inquiries, feedback, or collaborations. We’re happy to hear from you!
        </p>
      </div>

      {/* Contact Form */}
      <div
        style={{
          maxWidth: "700px",
          margin: "0 auto",
          backgroundColor: "#fff",
          padding: "2rem",
          borderRadius: "8px",
        }}
      >
        <form onSubmit={handleSubmit}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "1rem",
              marginBottom: "1rem",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label htmlFor="name" style={{ fontWeight: "bold", marginBottom: "0.5rem", color: "#333" }}>
                Your Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                style={{
                  padding: "0.75rem",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "1rem",
                  outline: "none",
                }}
                placeholder="Enter your full name"
              />
              {errors.name && <span style={{ color: "red", fontSize: "0.9rem" }}>{errors.name}</span>}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label htmlFor="email" style={{ fontWeight: "bold", marginBottom: "0.5rem", color: "#333" }}>
                Your Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                style={{
                  padding: "0.75rem",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "1rem",
                  outline: "none",
                }}
                placeholder="Enter your email address"
              />
              {errors.email && <span style={{ color: "red", fontSize: "0.9rem" }}>{errors.email}</span>}
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "column", marginBottom: "1rem" }}>
            <label htmlFor="description" style={{ fontWeight: "bold", marginBottom: "0.5rem", color: "#333" }}>
              Describe Your Need or Pitch a Project Idea
            </label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows="4"
              style={{
                padding: "0.75rem",
                border: "1px solid #ccc",
                borderRadius: "4px",
                fontSize: "1rem",
                outline: "none",
              }}
              placeholder="Briefly describe what you are trying to build..."
              required
            />
            {errors.description && (
              <span style={{ color: "red", fontSize: "0.9rem" }}>{errors.description}</span>
            )}
          </div>

          <div style={{ textAlign: "center" }}>
            <button
              type="submit"
              style={{
                padding: "0.75rem 1.5rem",
                backgroundColor: "#4f46e5",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                fontSize: "1rem",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#3b38d1")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#4f46e5")}
            >
              Submit
            </button>
          </div>
        </form>
      </div>

      {/* Contact Information */}
      <div style={{ marginTop: "2rem", textAlign: "center" }}>
        <h3 style={{ fontSize: "1.8rem", fontWeight: "bold", color: "#333" }}>Contact Information</h3>
        <p style={{ fontSize: "1rem", color: "#555", marginTop: "0.5rem" }}>
          Reach out to us via email or connect with us on social media.
        </p>
        <p>Email: <a href="mailto:info@geologicalsociety.com" style={{ color: "#4f46e5" }}>info@geologicalsociety.com</a></p>
        <p>Phone: +123 456 7890</p>
        <div style={{ marginTop: "1rem" }}>
          <a href="https://facebook.com" style={{ margin: "0 1rem", color: "#4f46e5", textDecoration: "none" }}>Facebook</a>
          <a href="https://twitter.com" style={{ margin: "0 1rem", color: "#4f46e5", textDecoration: "none" }}>Twitter</a>
          <a href="https://linkedin.com" style={{ margin: "0 1rem", color: "#4f46e5", textDecoration: "none" }}>LinkedIn</a>
        </div>
      </div>
    </div>
  );
}

export default Contact;
